import { createFileRoute } from '@tanstack/react-router';

import { TeamPage } from '@/features/team/team-page';

export const Route = createFileRoute('/_app/projects/$projectId/team')({
  component: TeamRoute,
});

function TeamRoute() {
  const { projectId } = Route.useParams();
  return <TeamPage projectId={projectId} />;
}
